import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Divider, SxProps, Menu, MenuItem } from '@mui/material';
import { title, typeText, card, infoText, menuItems } from './TemplateCard.sx';
import EditIcon from 'app/components/Icons/EditIcon';
import BanknoteIcon from 'app/components/Icons/BanknoteIcon';
import MenuEditIcon from 'app/components/Icons/MenuEditIcon';
import BinIcon from 'app/components/Icons/BinIcon';
import RenameIcon from 'app/components/Icons/RenameIcon';
import DeleteTemplateModal from 'app/pages/TemplatesPage/TemplateModals/DeleteTemplateModal';
import NameChangeModal from 'app/pages/TemplatesPage/TemplateModals/NameChangeModal';
import { useLocation, useNavigate } from 'react-router-dom';
import TableDotsIcon from 'app/components/Icons/TableDotsIcon';
import { useChangeNameTemplate, useDeleteTemplate, useEditTemplate } from 'app/utils/services/templateService';
import logger from 'app/utils/logger';
import CoinsSwapIcon from 'app/components/Icons/CoinsSwapIcon';
import BankIcon from 'app/components/Icons/BankIcon';
import ManatIcon from 'app/components/Icons/ManatIcon';
import GlobusIcon from 'app/components/Icons/GlobusIcon';
import SwitchIcon from 'app/components/Icons/SwitchIcon';
import CoinsStackedIconSelect from 'app/components/Icons/CoinsStackedIconSelect';
import WalletIconSelect from 'app/components/Icons/WalletIconSelect';
import FileIcon from 'app/components/Icons/FileIcon';
import TemplateFileIcon from 'app/components/Icons/TemplateFileIcon';
import CustomSnackbar from 'app/components/CustomSnackbar';

interface Props {
  id: string;
  sx?: SxProps;
  data?: any;
  type?: any;
  changeNameTemplateMutation?: any;
  deleteTemplateMutation: any;
  dataChangeName?: any;
}

const details = [
  {
    title: 'Adını dəyiş',
    icon: <RenameIcon />,
  },
  {
    title: 'Düzəliş et',
    icon: <MenuEditIcon sx={{ width: '18px', height: '18px' }} />,
  },
  {
    title: 'Sil',
    icon: <BinIcon sx={{ width: '18px', height: '18px' }} color={'warning'} />,
  },
];

const TemplateCard = (props: Props) => {
  const { id, type, data, sx, changeNameTemplateMutation, deleteTemplateMutation, dataChangeName } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeAnchor, setActiveAnchor] = useState('');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openNameChangeModal, setOpenNameChangeModal] = useState(false);
  const [templateName, setTemplateName] = useState('');
  const [cardId, setCardId] = useState('');
  const [obj, setObj] = useState({});
  const [error, setError] = useState(false);

  const location = useLocation();
  const lang = location.pathname.substring(0, 3);

  const pathUrl = location.pathname.substring(4);

  const navigate = useNavigate();

  const handleMenuClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (anchorEl !== null) {
      setActiveAnchor(anchorEl.getAttribute('aria-controls'));
    }
  }, [anchorEl]);

  const handleClickMenuItem = (index: number, idCard: any, objCard: any) => {
    setCardId(idCard);
    setObj(objCard);
    if (index === 0) {
      setOpenNameChangeModal(true);
      setTemplateName(data.title);
      setAnchorEl(null);
    }

    if (index === 1) {
      navigate(`/az/templates-page/edit-template?type=${data.transfer_type}`, {
        state: { templateData: data, templateId: id },
      });
    }

    if (index === 2) {
      setOpenDeleteModal(true);
      setAnchorEl(null);
    }
  };

  const handleClickCard = (e: any) => {
    if (e.target.nodeName !== 'svg' && e.target.nodeName !== 'path') {
      navigate(`/az/transfer-page?type=${data.transfer_type}`, { state: { templateData: data, templateId: id } });
    }
  };

  useEffect(() => {
    if (dataChangeName?.result === 'error') {
      setError(true);
    }

    if (dataChangeName?.result === 'accepted') {
      setOpenNameChangeModal(false);
    }
  }, [dataChangeName]);

  return (
    <>
      <Box sx={card} onClick={(e: any) => handleClickCard(e)}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Box sx={{ display: 'flex', gap: '12px', width: '100%' }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '48px',
                  minWidth: '48px',
                  height: '48px',
                  borderRadius: '8px',
                  backgroundColor: 'rgba(36, 176, 126, 0.08)',
                }}
              >
                {data.transfer_type === 'payment_acc2acc' ? (
                  <CoinsSwapIcon color={'warning'} />
                ) : data.transfer_type === 'payment_interbank' ? (
                  <BankIcon color={'warning'} />
                ) : data.transfer_type === 'payment_local_transfer' ? (
                  <ManatIcon color={'warning'} />
                ) : data.transfer_type === 'payment_foreign_transfer' ? (
                  <GlobusIcon color={'warning'} />
                ) : data.transfer_type === 'payment_conversion' ? (
                  <SwitchIcon color={'warning'} />
                ) : data.transfer_type === 'payment_edv' ? (
                  <CoinsStackedIconSelect color={'warning'} />
                ) : (
                  data.transfer_type === 'payment_budget' && <WalletIconSelect color={'warning'} />
                )}
                {/*<BanknoteIcon sx={{ width: '24px', height: '24px', color: 'transparent' }} color={'warning'} />*/}
              </Box>
              <Box sx={{ width: '100%' }}>
                <Typography sx={title}>{data.title}</Typography>
                <Typography sx={typeText}>{type}</Typography>
              </Box>
            </Box>
            <TableDotsIcon
              sx={{ width: '16px', height: '16px', cursor: 'pointer' }}
              onClick={(event: any) => handleMenuClick(event)}
            />
          </Box>
        </Box>
        <Divider />
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box
            sx={{
              display: 'flex',
              gap: '40px',
              '@media screen and (max-width: 768px)': { flexDirection: 'column', gap: '0' },
            }}
          >
            <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <Typography sx={typeText}>Məbləğ:</Typography>
              <Typography sx={infoText}>{data.amount}</Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <Typography sx={typeText}>Tarix:</Typography>
              <Typography sx={infoText}>{data.date}</Typography>
            </Box>
          </Box>
          {data.content_data.files !== undefined && data?.content_data.files.length > 0 && (
            <Box
              sx={{
                minWidth: '36px',
                height: '36px',
                background: 'rgba(20, 25, 31, 0.05)',
                borderRadius: '8px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <TemplateFileIcon />
            </Box>
          )}
        </Box>
      </Box>
      <Menu
        id={activeAnchor}
        disableAutoFocusItem
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{ '& .MuiPaper-root': { width: 'fit-content' } }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {details.map((detail, index) => (
          <MenuItem
            key={detail.title}
            sx={
              index + 1 === details.length
                ? { ...menuItems, color: '#FF5F57', '&:hover': { color: '#FF5F57', background: '#F3F4F6' } }
                : menuItems
            }
            onClick={() => handleClickMenuItem(index, id, data)}
          >
            {detail.icon} {detail.title}
          </MenuItem>
        ))}
      </Menu>
      {openDeleteModal && (
        <DeleteTemplateModal
          open={openDeleteModal}
          close={setOpenDeleteModal}
          id={cardId}
          deleteTemplate={deleteTemplateMutation}
        />
      )}
      {openNameChangeModal && (
        <NameChangeModal
          open={openNameChangeModal}
          close={setOpenNameChangeModal}
          templateName={templateName}
          id={cardId}
          changeNameTemplate={changeNameTemplateMutation}
          dataChangeName={dataChangeName}
          data={obj}
          error={error}
          setError={setError}
        />
      )}
    </>
  );
};

export default TemplateCard;
